export default "__VITE_ASSET__30b281ed__"